import { ProductInfo } from 'src/app/shared/product';

/** Numeric codes for all supported document types in the system. */
export enum DocumentType {
  ContractOrder = 1, // Договор-Заказ
  ReceiptInvoice = 2, // Приходная накладная
  ImportInvoice = 3, // Накладная на импорт
  OutgoingInvoice = 4, // Расходная накладная
  TransferInvoice = 5, // Накладная на перемещение
  TaxInvoice = 6, // Налоговая накладная
  WarrantySpec = 7, // Спецификация / Гарантийный талон
  CashReceipt = 8, // Приходные кассовый ордер
  BankStatement = 9, // Банковская выписка
  SupplierOrder = 10, // Требование-заказ для поставщика
  CommercialProposal = 12, // Коммерческое предложение
  Inventory = 14, // Инвентаризация
  Reconciliation = 15, // Сверка по взаиморасчетам
  Passport = 16, // Паспорт
}

/** Human-readable name registry for all `DocumentType` codes, keyed by English name. */
export const DocumentTypes = {
  ContractOrder: { id: 1, name: "Договор-Заказ" },
  ReceiptInvoice: { id: 2, name: "Приходная накладная" },
  ImportInvoice: { id: 3, name: "Накладная на импорт" },
  OutgoingInvoice: { id: 4, name: "Расходная накладная" },
  TransferInvoice: { id: 5, name: "Накладная на перемещение" },
  TaxInvoice: { id: 6, name: "Налоговая накладная" },
  WarrantySpec: { id: 7, name: "Спецификация / Гарантийный талон" },
  CashReceipt: { id: 8, name: "Приходные кассовый ордер" },
  BankStatement: { id: 9, name: "Банковская выписка" },
  SupplierOrder: { id: 10, name: "Требование-заказ для поставщика" },
  CommercialProposal: { id: 12, name: "Коммерческое предложение" },
  Inventory: { id: 14, name: "Инвентаризация" },
  Reconciliation: { id: 15, name: "Сверка по взаиморасчетам" },
  Passport: { id: 16, name: "Паспорт" },
} as const;

/** Document health flags — stored in `DOCFLAG`; 0 = OK, 10 = minor issue, 100 = serious error. */
export const DocumentStatusFlag = {
  EverythingIsOk: { value: 0, name: "Документ в порядке" },
  MinorIssue: { value: 10, name: "Документ сохранен с замечаниями" },
  SeriousError: { value: 100, name: "Документ сохранен с ошибками" },
} as const;


/*
 CREATE TABLE [dbo].[DocAccessRights](
	[OBJECTID] [int] NOT NULL,
	[SGMGROUPID] [int] NOT NULL,
	[OBJACCRIGHTS] [int] NOT NULL

 */

/*
 *
 * 
    this.docTypes =
       [
        { "DOCTYPEID": 1, "DOCKIND": 1, "DOCNAME": "Договор-Заказ", "DOCNAME1": "Договор на поставку", "DOCSGROUP1": "Выписано счетов" },
        { "DOCTYPEID": 2, "DOCKIND": 2, "DOCNAME": "Приходная накладная", "DOCNAME1": "Накладная на прием ТМЦ", "DOCSGROUP1": "Принято товара" },
        { "DOCTYPEID": 3, "DOCKIND": 2, "DOCNAME": "Накладная на импорт", "DOCNAME1": null, "DOCSGROUP1": "Принято импортного товара" },
        { "DOCTYPEID": 4, "DOCKIND": 2, "DOCNAME": "Расходная накладная", "DOCNAME1": "Накладная на отпуск ТМЦ", "DOCSGROUP1": "Отгружено товара" },
        { "DOCTYPEID": 5, "DOCKIND": 2, "DOCNAME": "Накладная на перемещение", "DOCNAME1": null, "DOCSGROUP1": null },
        { "DOCTYPEID": 6, "DOCKIND": 3, "DOCNAME": "Налоговая накладная", "DOCNAME1": null, "DOCSGROUP1": null },
        { "DOCTYPEID": 7, "DOCKIND": 3, "DOCNAME": "Спецификация / Гарантийный талон", "DOCNAME1": null, "DOCSGROUP1": null },
        { "DOCTYPEID": 8, "DOCKIND": 4, "DOCNAME": "Приходные кассовый ордер", "DOCNAME1": "Приходные кассовый ордер", "DOCSGROUP1": "Оплачено" },
        { "DOCTYPEID": 9, "DOCKIND": 4, "DOCNAME": "Банковская выписка", "DOCNAME1": "Платежное поручение покупателя", "DOCSGROUP1": "Оплачено" },
        { "DOCTYPEID": 10, "DOCKIND": 1, "DOCNAME": "Требование-заказ для поставщика", "DOCNAME1": null, "DOCSGROUP1": null },
        { "DOCTYPEID": 11, "DOCKIND": 4, "DOCNAME": "Взаимозачет", "DOCNAME1": "Залог", "DOCSGROUP1": "Оплачено" },
        { "DOCTYPEID": 12, "DOCKIND": 1, "DOCNAME": "Коммерческое предложение", "DOCNAME1": "Коммерческое предложение", "DOCSGROUP1": null },
        { "DOCTYPEID": 14, "DOCKIND": 2, "DOCNAME": "Инвентаризация", "DOCNAME1": "Инвентаризация склада", "DOCSGROUP1": "Отаток товаров на складе" },
        { "DOCTYPEID": 15, "DOCKIND": 4, "DOCNAME": "Сверка по взаиморасчетам", "DOCNAME1": null, "DOCSGROUP1": "Сверка по балансам" },
        { "DOCTYPEID": 16, "DOCKIND": 3, "DOCNAME": "Паспорт", "DOCNAME1": null, "DOCSGROUP1": null }]
      ;
*/

/*

      {
        path: 'edit-document/2/:id',
        component: EditDocumentReceiptComponent,
      },
      {
        path: 'edit-document/3/:id',
        component: EditDocumentReceiptComponent,
      },
      {
        path: 'edit-document/4/:id',
        component: EditDocumentReceiptComponent,
      },
      {
        path: 'edit-document/5/:id',
        component: EditDocumentReceiptComponent,
      },
      {
        path: 'edit-document/7/:id',
        component: EditDocumentSpecComponent,
      },
      {
        path: 'edit-document/10/:id',
        component: EditDocumentPoComponent,
      },
      {
        path: 'edit-document/14/:id',
        component: EditDocumentInventoryComponent,
      },
      {
        path: 'edit-document/16/:id',
        component: EditDocumentSpecComponent,
      },
      {
        path: 'edit-document/:type/:id',
        component: EditDocumentComponent,
      },


*/
/** Describes one importable column in the Excel/text import dialog — maps a column name/label to a target field, type, and optional default. */
export class ImportItemFields {

/*
  PRODCODE?: string;
  DOCITEMPRODNAME: string;
  DOCITEMPRICE: number;
  DOCITEMQTY: number;
  DOCITEMVPRICE: number;
  DOCITEMTEXT1: string;
  DOCITEMTEXT2: string;
  U4ETKA: number;
  */

  fieldName: string;
  fieldLabel: string;
  fieldType: string;
  fieldIsMandatory: boolean;

  importColumnName?: string;    // Placeholder to store real column name to import from

  fieldArea?: string;

  defaultValue?: string;
  anotherFieldNames?: string[];

  updateExisted?: boolean;

}



/** Defines which child document types can be created from a given parent `DOCTYPE`. */
export class DocInheritanceRule {
  DOCTYPE: number;
  AllowedChildTypes: number[];
}

// interface ProductInfo { [x: string]: any; };

/** Full document line-item entity — maps a `DocItems` DB row with pricing, quantities, currency, and per-item validation flags (bip/bmd/cnm/rnm/etc.). */
export class DocItems {

  DOCITEMID: number;
  DOCID: number;
  DOCTYPE?: number;
  PRODCODE?: string;
  PRODCUSTCODE?: string;
  PRODWWWPAGE?: string;
  PRODID: number;
  PRODKIND?: number;
  DOCITEMPRODNAME: string;
  DOCITEMPRICE: number;
  DOCITEMQTY: number;
  DOCITEMVPRICE: number;
  DOCITEMCURRID: number;
  DOCITEMCRATE: number;
  PAYITEMCLIID: number;
  PAYITEMDEPID: number;
  DOCITEMTEXT1: string;
  DOCITEMTEXT2: string;
  CURCODE: string;
  U4ETKA: number;
  PRODVAT?: number;
  DOCITEMPRICEWOVAT?: number;

  DOCITEMRETPRICE?: number;
  DOCITEMRETVPRICE?: number;
  DISCOUNT?: number;

  DOCITEMSUM?: number;
  DOCITEMVSUM?: number;
  DOCITEMSUMWOVAT?: number;
  DOCITEMSUMU4?: number;
  DOCITEMSUMWEIGHT?: number;

  DOCITEMSHIPPED?: number;

  DOCITEMGLOBALSTOCK?: number;
  DOCITEMLOCALSTOCK?: number;

  DOCITEMPOSHIPPINGDATE?: Date;     // Just to alow edit (reflect) the DOCITEMTEXT1 in PO

  DOCINCOMEPRICE?: number;          // These numbers are in main currency!
  DOCITEMPROFIT?: number;
  DOCITEMPROFITSUM?: number;

  PRODOEMNAME?: string;       // PRODMANUFID
  PRODBARCODEMASK?: string;       // EAN
  prodInfo?: ProductInfo;

  cloneIndex?: number;

  /**
   * In-memory only, never persisted: marks a row the AI Assist tab proposed, so
   * `onAgentItemsChange()` can rebuild its own proposals without disturbing rows a
   * manager added by hand in the products panel. `doSaveDocument()` posts named fields,
   * not the whole object, so this never reaches the API.
   */
  agentProposed?: boolean;

  /*
   * Getters to implement some business logics and checking
   */

  bip?: boolean;     // Below income price
  bmd?: boolean;     // Below max discount
  cnm?: boolean;     // Currency does not match
  rnm?: boolean;     // Currency Rate does not match stated in document
  pdp?: boolean;     // Primary document Price does not match
  cpn?: boolean;     // Saved currency price does not match stated in row

  mtc?: boolean;     // Missing tariff code
  nta?: boolean;     // Tariff code doesn't have approval

  sha?: boolean;     // Shipped already
  mst?: boolean;     // Missing on stock
  npc?: boolean;     // No product's Global Category set

  dmi?: boolean;     // Min discount
  dme?: boolean;     // Medium
  dma?: boolean;     // Maximum discount

  pdm?: boolean;     // Price does not match
  wns?: boolean;     // Weight does not stated
  //
  //  Below are two getters for receipts (4,5)
  //
  ngs?: boolean;     // Global stock less then shipped (DOCITEMQTY) quantity
  nls?: boolean;     // Local stock less then shipped (DOCITEMQTY) quantity

  /** DOCTYPE 5 backward-leg (manufacturing) lines only, complex products
   *  (PRODKIND=1): true when ufn_getmanufacturingbackdoc_recompute_iTVF's
   *  IsFullyConfirmed came back false (no matching forward legs, a
   *  PRIMDOCID mismatch, or a BOM quantity mismatch) — escalates to
   *  SeriousError, mirroring the same-severity BOM check
   *  new-document-dlg-process-tran-prod.component.ts already runs at
   *  document creation. See docs/PROMPT_manufacturing-backdoc-price-check-dialog.md. */
  mbc?: boolean;     // Manufacturing Backdoc unConfirmed
  /** Same scope as `mbc`, set when the match IS fully confirmed but the
   *  stored price still differs from the recomputed one beyond
   *  MISMATCH_TOLERANCE — escalates to MinorIssue. */
  mbm?: boolean;     // Manufacturing Backdoc price Mismatch

  lpf?: boolean;    // low profit (below zero)
  hlt?: boolean;    // Overall Health (true is not ok)

    /* doctypes.includes(1,12)
      рахунок фактура
      комерційна пропозиція

          + (di.bip ? 'Цена ниже входной! ' : '')
          + (di.bmd ? 'Скидка больше максимальной! ' : '')
          + (di.cnm ? 'Валюта не соответствует установленной в документе! ' : '')
          + (di.rnm ? 'Курс не соответствует установленному в документе! ' : '')
          + (di.cpn ? 'Валютная цена не соответствует расчетной! ' : '')
          + (di.mtc ? 'Не указан УКТЗЕД товара! ' : '')
          + (di.nta ? 'Не подтвержден УКТЗЕД товара! ' : '')
          + (di.lpf ? 'Возможный убыток от операции! ' : '')
          + (di.npc ? 'Не установлена категория товара ' : '')
  */

 /* doctypes.includes(2,3,4,5)

    накладна на отримання, видаткова, переміщення

      + (di.cnm ? 'Валюта не соответствует установленной в документе! ' : '')
      + (di.rnm ? 'Курс не соответствует установленному в документе! ' : '')
      + (di.cpn ? 'Валютная цена не соответствует расчетной! ' : '')
      + (di.mtc ? 'Не указан УКТЗЕД товара! ' : '')
      + (di.ngs ? 'На момент отгрузки недостаточно товара на складе! ' : '')
      + (di.nls ? 'На момент отгрузки недостаточно товара на складе юридического лица!  ' : '')
      + (di.pdp ? 'Цена отгрузки не соответствует первичному документу' : '')
 */

/* doctypes.includes(10)

  требование заказ (purchase order)

      + (di.cnm ? 'Валюта не соответствует установленной в документе! ' : '')
      + (di.rnm ? 'Курс не соответствует установленному в документе! ' : '')
      + (di.cpn ? 'Валютная цена не соответствует расчетной! ' : '')
      + (di.mtc ? 'Не указан УКТЗЕД товара! ' : '')
      + (di.wns ? 'Не указан вес товара! ' : '')
      + (di.pdm ? 'Не совпадает цена в инвойсе и в базе! ' : '')
*/

/*  doctypes.includes(7,16)

  гарантійний талон/паспорт 

      //    + (di.cnm ? 'Валюта не соответствует установленной в документе! ' : '')
      //    + (di.rnm ? 'Курс не соответствует установленному в документе! ' : '')
      //    + (di.mtc ? 'Не указан УКТЗЕД товара! ' : '')
      //    + (di.wns ? 'Не указан вес товара! ' : '')
      //    + (di.pdm ? 'Не совпадает цена в инвойсе и в базе! ' : '')
*/

  doptions?: { label: string, value: number }[];

}

/** Full document entity — mirrors the `Documents` DB table row with all header fields, computed sums, and line-item array. */
export class Document {

  DOCID: number;          // Document ID (primary key), database field
  DOCTYPE: number;        // Document type (e.g., invoice, order), database field
  DOCDATE: Date;          // Document date, database field
  DOCEXPDATE: Date;       // Document expiration date, database field
  DOCVALDATE: Date;       // Document valid to date, database field
  DOCCLIENTSID: number;   // Client ID (seller or buyer. depends on DOCTYPE), database field
  DOCPERSONID: number;    // Person ID (responsible person in client company), database field
  DOCMANCLIID: number;    // Managing Client ID (company receiving the products), database field
  DOCMANPERID: number;    // Managing Person ID (responsible person in managing company), database field
  DOCNUMBER: string;      // Document number (individual for every Client), text field to create human readable document number, database field
  DOCDLVBASE: string;     // Delivery base (terms of delivery), database field
  DOCDLVTERM: number;     // Delivery terms (in days), database field
  DOCNOTE1: string;       //  Document note 1, database field
  DOCNOTE2: string;       //  Document note 2, dependent on DOCTYPE, database field
  PRIMDOCID: number;      // Primary document ID (e.g., for invoice it is order ID), database field
  DOCCLIDEPID: number;    // Client department ID (department in client company), database field
  DOCMANDEPID: number;    // Managing department ID (department in managing company), database field
  DOCTOTALDISCOUNT: number; // Total discount for the document, generally not used, database field
  DOCCURRID: number;        // Currency ID (document currency), database field
  DOCRATEVAL: number;     // Currency rate value (document currency rate), database field
  DOCACTIVE: number;      // Document active flag (0 - inactive, 1 - active), database field
  DOCFLAG: number;        // Document flag (general purpose, depends on DOCTYPE), database field
                          // at the moment used to mark errorneous documents
                          // (100 - serious error, 10 - minor issue, 0 - everything is ok)
  DOCLCOCLIID: number;    // Legal Client ID (legal entity of the managing client), database field
  DOCLCOPERID: number;    // Legal Person ID (responsible person in legal entity of the managing client), database field
  DOCLCODEPID: number;    // Legal department ID (department in legal entity of the managing client), database field
  DOCPCOCLIID: number;    // Partner Client ID (partner company, e.g., supplier), database field
  DOCPCOPERID: number;    // Partner Person ID (responsible person in partner company), database field
  DOCPCODEPID: number;    // Partner department ID (department in partner company), database field

  DOCNUMBEREX?: string;   // Extended document number (for display purposes), database query computed field
  DOCNAMESTR?: string;    // Document name string (e.g., "Invoice", "Order" along with DOCNUMBER), database query computed field
  DOCSUM?: number;        // Document sum (total amount including VAT), database query computed field
  DOCVSUM?: number;       // Document sum in expressed in currency rate (pulled from DOCCURRID), database query computed field
  DOCSUMWOVAT?: number;   // Document sum without VAT, database query computed field
  DOCVAT?: number;        // Document VAT amount, database query computed field
  DOCITEMS?: number;      // Number of items in the document, database query computed field
  DOCTOTALITEMS?: number; // Total number of items (sum of quantities), database query computed field
  DOCSUMU4ETKA?: number;  // Document sum in U4ETKA (special sum of document. fraction of the total value), database query computed field
  DOCPAIDSUM?: number;    // Document paid sum (amount already paid), database query computed field
  DOCPAIDSUMVAL?: number; // Document paid sum expressed in currency rate, database query computed field
  DOCSHIPSUM?: number;    // Document shipped sum (amount already shipped), database query computed field
  SGMGROUPID?: number;    // Security group ID (for access control), database field (pulled from another table)

  HeaderStatement?: string; // Header statement for the document (e.g., terms and conditions), database field, pulled from DOCTYPE table
  FooterStatement?: string; // Footer statement for the document (e.g., legal disclaimers), database field, pulled from DOCTYPE table

  DOCCURNAME?: string;      // Document extended currency name (e.g., "USD", "EUR"), database query computed field

  items?: DocItems[];       // Array of document items (line items in the document), not stored directly in the Document table, but in DocItems table

  DOCSUMWEIGHT?: number;    // Document total weight (sum of weights of all items), database query computed field

  DOCSUMPROFIT?: number;    // 

  DOCUMENTISREADY?: boolean; // true if the whole document is ready to export or print
  DOCSTATUSFLAG?: number; // 0 - OK, 10 - minor issue, 100 - serious error
}

/** Blank `Document` used as the spread base by the create-new-document builders (`DOCDATE`/`DOCVALDATE`/`DOCEXPDATE` are frozen at module load — every builder overrides them). */
export const emptyDocument: Document = {
  DOCID: null,
  DOCTYPE: null,
  DOCDATE: new Date,
  DOCEXPDATE: new Date,
  DOCVALDATE: new Date,
  DOCCLIENTSID: null,
  DOCPERSONID: null,
  DOCMANCLIID: null,
  DOCMANPERID: null,
  DOCNUMBER: null,
  DOCDLVBASE: null,
  DOCDLVTERM: null,
  DOCNOTE1: null,
  DOCNOTE2: null,
  PRIMDOCID: null,
  DOCCLIDEPID: null,
  DOCMANDEPID: null,
  DOCTOTALDISCOUNT: null,
  DOCCURRID: null,
  DOCRATEVAL: null,
  DOCACTIVE: null,
  DOCFLAG: null,
  DOCLCOCLIID: null,
  DOCLCOPERID: null,
  DOCLCODEPID: null,
  DOCPCOCLIID: null,
  DOCPCOPERID: null,
  DOCPCODEPID: null,
  items: []
};

/**
 * One row from `GET /DocumentList/fastSearchByNumber` — the type-ahead search
 * behind `DocumentselectorComponent`'s live document lookup.
 *
 * Backed by `[dbo].[WY_tvf_searchDocumentByNumber_iTVF]` (`SQL-Database-migration`
 * PR #79, extended by PR #80 with `DOCTYPENAME` + optional `cliid`/`lcocliid`/
 * `doctypeFilter` narrowing) — a brand-new, purpose-built function (unlike the
 * earlier `[dbo].[WY_tvf_searchDocumentFast]`/`GET /DocumentList/fastSearch`
 * pairing this replaced, which was a pre-existing live DB object with no
 * definition checked into that repo). Every field below is a plain, known
 * column this function's own `SELECT` list defines — no index signature
 * needed, unlike the previous version of this interface.
 *
 * PR #79's base shape (`DOCID`/`DOCNUMBER`/.../`PARTNERNAME`) was confirmed
 * live by the owner (real `SET STATISTICS TIME` rehearsal, 2026-09-16).
 * `DOCTYPENAME` (PR #80) is **not yet live-verified** — that extension hasn't
 * itself been rehearsed against a live connection.
 */
export interface DocumentFastSearchResult {
  DOCID: number;
  DOCNUMBER: string;
  DOCTYPE: number;
  /** Human-readable document type name, e.g. "Договор-Заказ" (`COALESCE(DOCNAME1, DOCNAME)`
   *  from `dbo.webDocTypes`). `null` if the row's `DOCTYPE` has no matching reference row. */
  DOCTYPENAME: string | null;
  DOCDATE: Date;
  DOCSUM: number;
  PARTNERNIKNAME: string;
  PARTNERNAME: string;
}

/** Flat export payload for the jsreport print service — structured as nested Owner/Header/Seller/Buyer/Items/Summary/Conditions sections for template rendering. */
export class DocumentExport {
  DocumentId?: number;

  ExportOptions?: {
    ShowDiscount?: boolean;
    ShowCurrency?: boolean;
    ShowItem?: boolean;
    ShowStamp?: boolean;
    ShowSign: boolean;
  };

  Owner?: {
    FullNameLabel?: string;
    PhoneLabel?: string;
    EmailLabel?: string;

    FullName?: string;
    Phone?: string;
    Email?: string;
  };

  Header?: {
 
    DocumentNumberLabel?: string;
    DocumentNameLabel?: string;
    DateLabel?: string;
    ValidToLabel?: string;
    ExpiredOnLabel?: string;

    CurrencyNameLabel?: string;
    CurrencyRateLabel?: string;

    MainCurrencyNameLabel?: string;
    MainCurrencyName?: string;

    DocumentNumber?: string;
    DocumentName?: string;
    Date?: Date;
    ValidTo?: Date;
    ExpiredOn?: Date;

    DateStr?: string;
    ValidToStr?: string;
    ExpiredOnStr?: string;

    CurrencyName?: string;
    CurrencyRate?: number;

    ParentDocumentNameLabel?: string;
    ParentDocumentName?: string;

  };

  Seller?: {
    CLIID?: number;
    PERID?: number;
    LogoImage?: string;
    StampImage?: string;
    SignImage?: string;

    CompanyNameLabel?: string;
    CompanyIdLabel?: string;
    VATIDLabel?: string;
    VATIDDocLabel?: string;
    AccountLabel?: string;
    BankLabel?: string;
    AddressLabel?: string;
    Account2Label?: string;

    FullNameLabel?: string;
    PhoneLabel?: string;
    EmailLabel?: string;

    CompanyName?: string;
    CompanyId?: string;
    VATID?: string;
    VATIDDoc?: string;
    Account?: string;
    Bank?: string;
    Address?: string;
    Account2?: string;

    FullName?: string;
    Phone?: string;
    Email?: string;
  };

  Buyer?: {
    CompanyNameLabel?: string;
    CompanyIdLabel?: string;
    VATIDLabel?: string;
    VATIDDocLabel?: string;
    AccountLabel?: string;
    BankLabel?: string;
    AddressLabel?: string;
    Account2Label?: string;

    FullNameLabel?: string;
    PhoneLabel?: string;
    EmailLabel?: string;

    CompanyName?: string;
    CompanyId?: string;
    VATID?: string;
    VATIDDoc?: string;
    Account?: string;
    Account2?: string;
    Bank?: string;
    Address?: string;

    FullName?: string;
    Phone?: string;
    Email?: string;
  };

  ItemsLabel?: {
    ItemCodeLabel?: string;
    ItemNameLabel?: string;
    ItemUrlLabel?: string;
    ItemTariffCodeLabel?: string;
    ItemNoteLabel?: string;
    ItemTextLabel?: string;

    ItemQntyLabel?: string;
    ItemPriceLabel?: string;
    ItemSumLabel?: string;
    ItemVSumLabel?: string;
    ItemVATLabel?: string;

    ItemSumWoVATLabel?: string;
    ItemPriceWoVATLabel?: string;
    ItemVPriceLabel?: string;
    ItemRetailPriceLabel?: string;
    ItemRetailVPriceLabel?: string;
    ItemDiscountLabel?: string;

    ItemVendorPriceLabel?: string;
    ItemInvoicePriceLabel?: string;
    ItemInvoiceSumLabel?: string;

    ItemIncomePriceLabel?: string;
    ItemIncomeSumLabel?: string;

    ItemProdWeightLabel?: string;
    ItemProdWeightSumLabel?: string;

    ItemContentLabel?: {
      ContentHeader?: string;
      ItemStrLabel?: string;
      ItemCodeLabel?: string;
      ItemNameLabel?: string;
      ItemQntyLabel?: string;
      ItemPriceLabel?: string;
      ItemVPriceLabel?: string;


    };
  };


  Items?: {
    ItemCode?: string;
    ItemName?: string;
    ItemURL?: string;
    ItemTariffCode?: string;
    ItemNote?: string;
    ItemText?: string;

    ItemQnty?: number;
    ItemPrice?: number;
    ItemSum?: number;
    ItemVSum?: number;
    ItemVAT?: number;

    ItemSumWoVAT?: number;
    ItemPriceWoVAT?: number;
    ItemVPrice?: number;
    ItemRetailPrice?: number;
    ItemRetailVPrice?: number;
    ItemDiscount?: number;

    ItemVendorPrice?: number;

    ItemInvoicePrice?: number;
    ItemInvoiceSum?: number;

    ItemIncomePrice?: number;
    ItemIncomeSum?: number;

    ItemProdWeight?: number;
    ItemProdWeightSum?: number;

    ItemContent?: {
      ItemStr?: string;
      ItemCode?: string;
      ItemName?: string;
      ItemQnty?: number;
      ItemPrice?: number;
      ItemVPrice?: number;
    }[];

  }[];

  Summary?: {

    TotalSumLabel?: string;
    TotalVSumLabel?: string;
    TotalSumWithOutVATLabel?: string;
    TotalSumVATLabel?: string;
    TotalItemsLabel?: string;
    TotalQuantityLabel?: string;
    TotalInvoiceSumLabel?: string;
    TotalInvoiceWightLabel?: string;

    TotalByWordsLabel?: string;

    TotalSum?: number;
    TotalVSum?: number;
    TotalSumWithOutVAT?: number;
    TotalSumVAT?: number;
    TotalItems?: number;
    TotalQuantity?: number;

    TotalInvoiceSum?: number;
    TotalInvoiceWight?: number;

    TotalByWords?: string;
  };

  Conditions?: {
    DeliveryConditionsLabel?: string;
    PaymentConditionsLabel?: string;
    DocumentNoteLabel?: string;
    DocumentNote2Label?: string;
    DeliveryTermsLabel?: string;

    PrefaceStatementLabel?: string;
    FooterStatementLabel?: string;

    DeliveryConditions?: string;
    PaymentConditions?: string;
    DeliveryTerms?: number;
    DocumentNote?: string;
    DocumentNote2?: string;

    PrefaceStatement?: string;
    FooterStatement?: string;
  };

}


